import React from 'react'
import { useValue, Form, ExecuteOperationOnPipe } from '@morningtrain/react-resources'
import { Translation } from '@morningtrain/react-translations'
import useDepartments from 'support/hooks/use-departments'
import { Input, Hidden } from 'support/fields'
import { SecondaryHeading } from 'ui/headings'
import * as Icons from 'ui/icons'
import { SquareButton, Button } from 'ui/buttons'

export default function EmploymentIdsEdit ({ children }) {
  const [departments] = useDepartments()
  const employmentIdsMap = useValue('employment_ids')

  const departmentIds = Object.keys(employmentIdsMap || {})

  function getDepartmentName (id) {
    for (const departmentIndex in departments) {
      const department = departments[departmentIndex]

      if (parseInt(department.id) === parseInt(id)) {
        return department.name
      }
    }

    return null
  }

  const [isEditing, setIsEditing] = React.useState(false)

  return (
    <div className='space-y-4'>
      <div className='flex justify-between'>
        <SecondaryHeading>
          <Translation name='titles.employee_ids' />
        </SecondaryHeading>
        <SquareButton color='btn-outlineLight' onClick={() => setIsEditing(!isEditing)}>
          <Icons.Settings />
        </SquareButton>
      </div>
      {isEditing ? (
        <Form route='api.salary.employment_numbers.update'>
          <ExecuteOperationOnPipe namespace='api' resourceName='salary.salary_period' operationName='overview' />

          <div className='space-y-4'>
            <Hidden name='user' fromName='id' />
            {departmentIds.map(departmentId => {
              return (
                <Input name={'employment_ids.' + departmentId} label={getDepartmentName(departmentId)} />
              )
            })}
            <Button type='submit'>
              <Translation name='actions.update_numbers' />
            </Button>
          </div>
        </Form>
      ) : null}
    </div>
  )
}
